import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useNavigationStackSafe } from "@/contexts/NavigationStackContext";
import { useAuth } from "@/contexts/AuthContext";
import { readHistoryIdx, resolveStackDismissDelta } from "@/components/navigation/stackDismissModel";
import { HOME, ROOT } from "@/routes";

export function useAppBack() {
  const navigate = useNavigate();
  const navStack = useNavigationStackSafe();
  const { isAuthenticated } = useAuth();

  return useCallback(() => {
    const currentIdx = readHistoryIdx();
    const topOfStack = navStack?.stack[navStack.stack.length - 1];
    const fallback = isAuthenticated
      ? (navStack?.activeTab ? navStack.getTabPath(navStack.activeTab) : HOME())
      : ROOT();

    // A stack overlay returns to the entry it was opened over, however many
    // duplicate or forward entries history has collected above it since.
    const dismissDelta = resolveStackDismissDelta({
      underIdx: topOfStack?.underIdx ?? null,
      currentIdx,
    });
    if (dismissDelta !== null) {
      navigate(dismissDelta);
      return;
    }

    if ((currentIdx ?? 0) > 0) {
      navigate(-1);
      return;
    }

    navigate(fallback, { replace: true });
  }, [navStack, isAuthenticated, navigate]);
}
